function importAll(r) {
    r.keys().forEach(r);
}

// Dynamically import all JS files in the current directory
importAll(require.context('./', true, /\.js$/));
